import { useContext } from 'react';
import AuditLogTableContext from '../../context/AuditLogTableContext';

export function useAuditLogTableContext() {
  return useContext(AuditLogTableContext);
}
